<template lang="">
    <v-app>
        <v-container fluid>
            <v-card>
                <v-card-title>
                    <span class="display-1">Históricos</span>
                    <v-spacer></v-spacer>
                </v-card-title>
                <!--FILTRO-->
                <div class="mb-4 mt-2 pl-3 pr-3">
                    <v-row class="justify-center">      
                        <v-col cols="12" md="2">
                            <v-menu v-model="fechaInicioInput" :close-on-content-click="false" 
                            :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="fechaInicio"
                                        label="Fecha Inicio"
                                        prepend-icon="mdi-calendar"
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker locale = "es-ES" first-day-of-week="1" v-model="fechaInicio" @input="fechaInicioInput = false"></v-date-picker>
                            </v-menu>
                        </v-col> 
                        <v-col cols="12" md="2">
                            <v-menu v-model="fechaFinInput" :close-on-content-click="false" 
                            :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="fechaFin"
                                        label="Fecha Fin"
                                        prepend-icon="mdi-calendar"
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker locale = "es-ES" first-day-of-week="1" v-model="fechaFin" @input="fechaFinInput = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="2"> 
                            <v-text-field v-model="trabajador" label="Trabajador" type=string></v-text-field> 
                        </v-col>    
                        <v-col cols="12" md="2"> 
                            <v-text-field v-model="lote_mp" label="Lote MP" type=string></v-text-field> 
                        </v-col> 
                        <v-col cols="12" md="2"> 
                            <v-text-field v-model="lote_bolson" label="Lote Bolson" type=string></v-text-field>
                        </v-col> 
                        <v-col cols="12" md="2"> 
                            <v-text-field v-model="lote_membrana" label="Lote membrana" type=string></v-text-field>
                        </v-col> 
                    </v-row>  
                    <v-row>
                        <v-col cols="11" class="text-center"> 
                            <v-btn @click="getDatosEnsayos"
                            block
                            color="primary">
                                <v-icon>BUSCAR</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col>
                            <v-btn color="primary">
                                <v-icon @click="downloadCiclos">
                                    mdi-download
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row justify="center" align="center" class="pa-5">
                        <v-col cols="12" md="8" lg="6">
                            <v-card v-if="cargandoDatos" elevation="2" class="pa-4 text-center">
                            <v-card-text>
                                <div class="text-h6 mb-2 primary--text font-weight-bold">
                                Cargando datos históricos
                                </div>
                                <div class="grey--text text--darken-1 mb-4">
                                Por favor, espere... {{ porcentajeProgreso }}%
                                </div>
                                
                                <v-progress-linear
                                v-model="porcentajeProgreso"
                                color="primary"
                                height="25"
                                reactive
                                rounded
                                striped
                                >
                                <template v-slot:default="{ value }">
                                    <span class="white--text font-weight-bold">{{ Math.ceil(value) }}%</span>
                                </template>
                                </v-progress-linear>
                            </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
                <!--TABLA-->
                <v-data-table
                    :loading="loading"
                    itemKey="id"
                    :headers="headersTablaCiclos"
                    :items="datos"
                    :options="options"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                >
                    
                    <template v-slot:[`item.fechahora_ensayo`]="{ item }">
                        {{item.nombre}}
                    </template>
                    
                    <template v-slot:[`item.dia`]="{ item }">
                        {{fecha_formateada(item.fechahora_ensayo).split(' ')[0]}}
                    </template>
                    
                    <template v-slot:[`item.hora`]="{ item }">
                        {{fecha_formateada(item.fechahora_ensayo).split(' ')[1]}}
                    </template>

                     <template v-slot:[`item.ok`]="{ item }">
                        <div v-if="item.conseguido">
                            <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn :color="color_conseguido(item)"
                                        dark
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                        <v-icon class="pointer">
                                            mdi-information-outline
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>
                                    <v-card :color="item.tiempo_por_debajo_limite_fase_3 > item.hig1_tiempo_seg ? '#FF0000' : '#00FF00'">
                                        <v-card-title>Fase 1 higienización</v-card-title>
                                        <v-card-subtitle>
                                            <v-row>Temperatura  {{item.hig1_temperatura}}ºC   </v-row>
                                            <v-row>Tiempo  {{Math.round(item.hig1_tiempo_seg/60)}}mins</v-row>
                                        </v-card-subtitle>
                                        <v-card-text>
                                            Transcurrido: 
                                            {{ Math.round(item.tiempo_por_debajo_limite_fase_3/60)}} mins
                                        </v-card-text>
    
                                    </v-card>
                                   
                                    <v-card :color="item.tiempo_por_debajo_limite_fase_4 > item.hig2_tiempo_seg ? '#FF0000' : '#00FF00'">
                                        <v-card-title>Fase 2 higienización</v-card-title>
                                        <v-card-subtitle>
                                            <v-row>Temperatura  {{item.hig2_temperatura}}ºC   </v-row>
                                            <v-row>Tiempo  {{Math.round(item.hig2_tiempo_seg/60)}}mins</v-row>
                                        </v-card-subtitle>
                                        <v-card-text>
                                            Transcurrido: 
                                            {{Math.round(item.tiempo_por_debajo_limite_fase_4/60)}} mins
                                        </v-card-text>
                                    </v-card>
                                </span>
                            </v-tooltip>
                            <div>
                                {{text_resultado(item)}}
                            </div>
                        </div>
                        <div v-else>
                            Esperando...
                        </div>
                    </template>

                    <template v-slot:[`item.t_secado`]="{ item }">
                        <div v-if="item.conseguido">
                            {{ calcularTiempoSecado(item.datos_de_ensayo.results) }}
                        </div>
                        <div v-else>
                            Esperando...
                        </div>
                    </template>

                    <template v-slot:item.actions="{ item }">
                        <v-icon small @click="editItem(item)" v-if="permiso_admin">
                            mdi-pencil
                        </v-icon>
                        <v-icon @click="showGraphicAndTable(item)">
                            mdi-finance
                        </v-icon>
                        <v-icon @click="downloadCiclo(item)">
                            mdi-download
                        </v-icon>
                    </template>
                    <template v-slot:top>
                        <v-dialog max-width="500px" v-model=editDialog>
                            <v-card>
                                <v-card-title>
                                    <span class="text-h5"> Editar Ensayo </span>
                                </v-card-title>
                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-col>
                                                <v-text-field 
                                                    v-model="lote_mp" 
                                                    label="Lote MP"
                                                    required>
                                                </v-text-field>
                                            </v-col>
                                            
                                            <v-col>
                                                <v-text-field 
                                                    v-model="lote_membrana" 
                                                    label="Lote Membrana higenizada"
                                                    required>
                                                </v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row>
                                            <v-col>
                                                <v-text-field 
                                                    v-model="lote_bolson" 
                                                    label="Lote Bolson"
                                                    required>
                                                </v-text-field>
                                            </v-col>

                                            <v-col>
                                                <v-text-field 
                                                    v-model="kg_membrana_t2" 
                                                    label="KG membrana T2"
                                                    required>
                                                </v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row>
                                            <!-- <v-col>
                                                <v-select :items="opcionesCuerpos" item-text="opcion" item-value="valor" v-model="editedItem.cuerpos_extr" label="Cuerpos extraños"></v-select>
                                            </v-col> -->

                                            <v-col>
                                                <v-text-field 
                                                    v-model="trabajador" 
                                                    label="Trabajador"
                                                    required>
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
    
                                    </v-container>
                                </v-card-text>
                                <!-- Las acciones -->
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="closeEdit">
                                        Cancelar
                                    </v-btn>
                                    <v-btn color="blue darken-1" text @click="saveEdit">
                                        Guardar
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </template>

                </v-data-table>
                <!-- Apartado que se muestra cuando queremos ver un ciclo -->
                <div v-if="seeGraphic">
                    <v-row class="float-right">
                        <v-btn
                            class="float-right"
                            fab
                            x-small
                        >
                            <v-icon dark @click="closeGraphic()">
                                mdi-close
                            </v-icon>
                        </v-btn>
                    </v-row>
                    <v-row>
                        <GraficoYTabla :datos="datosCiclo" :ensayo="ciclo_seleccionado" />
                    </v-row>
                    
                </div>
                <!--ALERT-->
                <v-alert v-if="mensajeError" dense outlined type="error"> {{mensajeError}}</v-alert>
            </v-card>
        </v-container>
  </v-app>
</template>
<script>
import GraficoYTabla from '@/components/GraficoYTabla.vue'
import { ExportToCsv } from 'export-to-csv';
import moment from 'moment-timezone';
import Swal from 'sweetalert2'
import { mapActions } from 'vuex';


export default {
    data() {
        return {
            sortBy:"fechahora_ensayo",
            sortDesc:true,
            ciclo_seleccionado:{},
            loading: false,
            mensajeError: '',
            trabajador: null,
            lote_mp: null,
            lote_bolson: null,
            lote_membrana: null,
            fechaInicio: this.getCurretDate(),
            fechaFin: this.getCurretDate(),
            fechaInicioInput: false,
            fechaFinInput: false,
            datosDesdeDíaAnterior: [],
            datos: [],
            datosCiclo: [],
            pruebaDatos: [{ id_ensayo: 2, day: "05 October 2011 14:48 UTC", lote_mp: 2, lote_bolson: 1, cuerpos_extr: 24, phase: 2, worker: "Manuel Cabezabolo", caudal_aire: 31, temperatura_tromel: 24.2, temperatura_salida: 257, date: "2020-08-12 T 00:08" }],
            seeGraphic: false,
            headersTablaCiclos: [
                // { text: "ID", align: "center", value: "id_ensayo" },
                // { text: "Nombre", align: "center", value: "nombre" },
                { text: "Nombre", align: "center", value: "fechahora_ensayo"},
                { text: "Día", align: "center", value: "dia"},
                { text: "Hora", align: "center", value: "hora"},
                // { text: "fechahora_ensayo", align: "center", value: "fechahora_ensayo"},
                { text: "KG entrada", align: "center", value: "kg_entrada" },
                { text: "KG salida", align: "center", value: "kg_membrana_t2" },
                { text: "LOTE MP", align: "center", value: "lote_mp" },
                { text: "LOTE Bolsón", align: "center", value: "lote_bolson" },
                { text: "LOTE membrana higenizada", align: "center", value: "lote_mem_higenizada" },
                // { text: "Cuerpos extraños", align: "center", value: "cuerpos_extr" },
                { text: "Trabajador", align: "center", value: "worker" },
                { text: "Resultado", align: "center", value: "ok" },
                { text: "Tiempo secado", align: "center", value: "t_secado" },
                { text: 'Acciones', value: 'actions', sortable: false },
            ],
            options: {
                itemsPerPage: 50,
            },
            editDialog: false,
            editedItem: {
                id_ensayo: -1,
                cuerpos_extr: false,
            },
            kg_membrana_t2: null,
            opcionesCuerpos: [
                {opcion: 'SI', valor: true},
                {opcion: 'NO', valor: false},
            ],
            permiso_admin: false,
            item_ant: {
                lote_mp: '',
                lote_bolson: '',
                lote_mem_higenizada: '',
                kg_membrana_t2: '',
            },
            cargandoDatos: false,
            porcentajeProgreso: 0,
            datosHistoricos: {}
        }
    },
    watch: {
        editDialog(val) {
            val || this.closeEdit() //Ejecutado cuando clicamos fuera del dialogo
        },
    },
    methods: {
        ...mapActions(['getData','postData','postDataWithReturn','putData']),
        fecha_formateada(f){
            return moment(f).format('YYYY-MM-DD HH:mm:ss')
        },
        getCurretDate() {
            return (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
        },
        getDayFromDate(date) {
            return date.split(' ')[0]
        },
        getHourFromDate(date) {
            return date.split('T')[1].substring(0, 8);
        },
        getAsyncDatosEnsayo(id_ensayo,elemento){
            const  params= {
                ciclo: id_ensayo
            }
            const payload = {
                 path: "alarms/alarms",
            }
            this.getData(payload,params)

        },
        getTiempoEnFasePorDebajoDeTemperatura(en_fase,element,nombre_fase){
            let segundos_seguidos_incumpliendo=0;
            let era=false;
            en_fase.forEach(el => {
            if(el['temperatura_tromel']<element[nombre_fase]){
                if(!era){
                    era=true;
                }else{
                    segundos_seguidos_incumpliendo++;
                }
            }else{
                era=false;
            }
                        
            });
            return segundos_seguidos_incumpliendo
           
        },
        async cargarHistoricoBulk(idsEnsayo) {
            if (!idsEnsayo || idsEnsayo.length === 0) return;

            this.cargandoDatos = true;
            this.porcentajeProgreso = 0;
            this.datosHistoricos = {}; // Resetear datos previos
            
            const chunkSize = 50;
            const totalIds = idsEnsayo.length;
            let procesados = 0;

            try {
                for (let i = 0; i < totalIds; i += chunkSize) {
                    const chunk = idsEnsayo.slice(i, i + chunkSize);
                    
                    const payloadBulk = {
                        path: 'ciclos/get-historico-ciclos-bulk2',
                        method: 'POST',
                        body: { ids: chunk }
                    };

                    const res = await this.postDataWithReturn(payloadBulk);
                    
                    if (res && res.ok) {
                        // Unimos los nuevos resultados con lo que ya tenemos
                        // Usamos Object.assign para mantener la reactividad en Vue 2
                        this.datosHistoricos = { ...this.datosHistoricos, ...res.results };
                    }

                    // Actualizamos el progreso
                    procesados += chunk.length;
                    this.porcentajeProgreso = Math.round((procesados / totalIds) * 100);
                    
                    console.log(`Cargado: ${this.porcentajeProgreso}%`);
                }
            } catch (error) {
                console.error("Error cargando bloques:", error);
            } finally {
                this.cargandoDatos = false;
                // Opcional: ocultar la barra tras un segundo
                // setTimeout(() => { this.porcentajeProgreso = 0; }, 1000);
            }
        },
        async getDatosEnsayos() { //Obtención datos para la primera tabla que muestra los distintos ciclos realizados
            this.loading = true
            const firstDay = moment(this.fechaInicio).subtract(1, 'days').format('YYYY-MM-DD')//this.fechaInicio,
            console.log(`primer dia ${firstDay}`)
            //this.actualizarCiclosDesdeDíaAnterior()
            const params= {
                firstDay,
                lastDay: this.fechaFin,
                lote_mp: this.lote_mp,
                lote_bolson: this.lote_bolson,
                lote_membrana: this.lote_membrana,
                worker: this.trabajador
            }
            console.log('Pido desde ' + firstDay + ' hasta ' + params.lastDay);
            console.log(params)
            const payload = {
                path: 'ciclos/get-historico-ensayos',
                params: params
            }
            const res = await this.getData(payload);
            console.log(res)
            
            // console.log(res);
            //Ciclos con datos del día anterior
            this.datos = res.results
            
            //dia anterior desde las 6:00
            let dia_anterior_despues_6 = moment(this.fechaInicio).subtract(1, 'days').set('hour',6).set('minute',0)
            console.log(`dia anterior a las 6 ${dia_anterior_despues_6}`)
            
            let todos = JSON.parse(JSON.stringify(this.datos))
            todos = todos.filter(b=> (moment(b.fechahora_ensayo).diff(dia_anterior_despues_6)>0))
            let todosTr = []
            todos.forEach(element => {
                todosTr.push(`${moment(element.fechahora_ensayo)}` )
            });
            console.log(todosTr)
            
            //solo datos desde fecha inicio elegido en filtro
            this.datos= this.datos.filter(a=>(moment(a.fechahora_ensayo).diff(moment(this.fechaInicio + ' 06:00:00'))>0))
            // return
          

            this.datos.forEach(element => {

                let dia = moment(element.fechahora_ensayo).format('YYYY-MM-DD')

                //Día anterior al de la fecha del ciclo actual
                let diaAnterior6 = moment(element.fechahora_ensayo).subtract(1, 'days').set('hour',6).set('minute',0).set('second',0)
                let diaActual6 = moment(element.fechahora_ensayo).set('hour',6).set('minute',0)
                let momentoActual = moment(element.fechahora_ensayo)



                //let dia_anterior = moment(element.fechahora_ensayo).subtract(1, 'days').format('YYYY-MM-DD')
                let hora = moment(element.fechahora_ensayo).format('HH:mm')
                let hora_num = parseInt(hora.split(':')[0])
                let momentFechaEnsayo6 = moment(element.fechahora_ensayo).set('hour',6).set('minute',0).set('second',0)
                let momentFechaEnsayo = moment(element.fechahora_ensayo)
                

                const dia_anterior_prefijo =  moment(element.fechahora_ensayo).subtract(1, 'days').format('YYYY/MM/DD')
                const dia_actual_prefijo =  moment(element.fechahora_ensayo).format('YYYY/MM/DD')

                console.log(`dia:${dia} hora:${hora} hora_num:${hora_num}`)
                //Si la hora es <6 hay que sumar al dia anterior
                let hastaAhora=[]
                let prefijo = '';
                if(hora_num<6){
                    //Prefijo tiene que coger la fecha del dia anterior
                    prefijo=dia_anterior_prefijo;

                    hastaAhora = todos.filter(g=>{
                        let fechaActualEnTotal = moment(g.fechahora_ensayo)
                        let diferencia_dia_anterior = diaAnterior6.diff(fechaActualEnTotal)
                        let diferencia_momento_ensayo = momentFechaEnsayo.diff(fechaActualEnTotal)
                        return((diferencia_dia_anterior<0) && (diferencia_momento_ensayo>0))

                    })
                }else{
                    prefijo=dia_actual_prefijo;

                    //Coger todos desde las 6 de la mañana hasta la hora actual
                                     //nos quedamos con todos los del día actual a partir de las 6 de la mañana
                    // hastaAhora = todos.filter(g=>( moment(g.fechahora_ensayo).diff(momentFechaEnsayo6) >0  ))
                    // hastaAhora = hastaAhora.filter(g=>( momentFechaEnsayo.diff(moment(element.fechahora_ensayo)) >0  ))
                    //element['nombre']=hastaAhora.length+1;
                    hastaAhora = todos.filter(g=>{
                        let fechaActualEnTotal = moment(g.fechahora_ensayo)
                        let diferencia_dia_anterior = momentFechaEnsayo6.diff(fechaActualEnTotal)
                        let diferencia_momento_ensayo = momentFechaEnsayo.diff(fechaActualEnTotal)
                        return((diferencia_dia_anterior<0) && (diferencia_momento_ensayo>0))

                    })

                }
                element['nombre']=`${prefijo}-${hastaAhora.length+1}`;
            });

            this.loading = false
            this.datos.map(er=>er['conseguido']=false)
            // 1. Extraer todos los IDs de los ensayos obtenidos
            const idsEnsayo = this.datos.map(d => d.id_ensayo);

            if (idsEnsayo.length > 0) {
                try {
                    // 2. Pedir TODOS los históricos en una sola llamada
                    await this.cargarHistoricoBulk(idsEnsayo);
                    console.log("cargarHistoricoBulk");
                    console.log(this.datosHistoricos);
                    
                    // const todosLosHistoricos = resBulk.results;

                    // 3. Procesar los datos localmente
                    this.datos.forEach(element => {
                        const id = element['id_ensayo'];
                        const historicoDeEsteCiclo = this.datosHistoricos[id] || [];
                        
                        element['datos_de_ensayo'] = { results: historicoDeEsteCiclo };

                        // Comprobar fases (tu lógica original)
                        let en_fase_3 = historicoDeEsteCiclo.filter(el => el['phase'] == 3);
                        element['tiempo_por_debajo_limite_fase_3'] = this.getTiempoEnFasePorDebajoDeTemperatura(en_fase_3, element, 'hig1_temperatura');
                        
                        let en_fase_4 = historicoDeEsteCiclo.filter(el => el['phase'] == 4);
                        element['tiempo_por_debajo_limite_fase_4'] = this.getTiempoEnFasePorDebajoDeTemperatura(en_fase_4, element, 'hig2_temperatura');
                        
                        element['ok'] = ((element['tiempo_por_debajo_limite_fase_3'] < element['hig1_tiempo_seg']) &&
                                        (element['tiempo_por_debajo_limite_fase_4'] < element['hig2_tiempo_seg']));
                        element['conseguido'] = true;
                        console.log("element: " + element);
                    });

                } catch (err) {
                    console.error("Error cargando históricos:", err);
                }
            }

            this.loading = false;
            // Forzar reactividad si es necesario
            this.datos = [...this.datos];
        },
        async getDatosCiclo(item) { //Función que llamamos cuando queremos obtener todos los datos de un ciclo
           
           this.loading = true
           this.datosCiclo=[];
           const payload = {
                path: 'ciclos/get-historico-ciclo',
                params: {ciclo: item.id_ensayo}
            }
           const res = await this.getData(payload)
            
            if (res.ok) {
                this.mensajeError = ''                        
                this.datosCiclo = res.results
                this.datosCiclo.splice()
                this.loading = false
            }
            else
                this.mensajeError = res.message
            
            this.loading = false
        },
        async showGraphicAndTable(item) {
            this.seeGraphic = false
            this.ciclo_seleccionado=item
            this.ciclo_seleccionado.nombre=item.nombre
            await this.getDatosCiclo(item)
            this.seeGraphic = true
        },
        closeGraphic() {
            this.seeGraphic = false
        },
        async downloadCiclo(item){

            await this.getDatosCiclo(item)

            let current_ciclo = JSON.parse(JSON.stringify(this.datosCiclo));
            console.log(current_ciclo);

            current_ciclo.forEach(element => {
                console.log(element);
                let prueba = new Date(element.date.replace(' ', 'T'));
                delete element.day
                //element.date=moment(prueba).format('YYYY-MM-DD HH:mm:ss')
                element['dia']=moment(prueba).format('YYYY-MM-DD')
                element['hora']=moment(prueba).format('HH:mm:ss')
                delete element['date']
            });


            //copia profunda y luego aplicar momentum
            //moment(prueba).format('YYYY-MM-DD HH:mm')

            const options = { 
                fieldSeparator: ';',
                quoteStrings: '"',
                decimalSeparator: ',',
                showLabels: true, 
                showTitle: false, // Sin titulo
                title: "Prueba", // Si ponemos título especificamos aquí
                useTextFile: false,
                useBom: true,
                useKeysAsHeaders: true,
                filename: item.nombre
                // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
            };
            const csvExporter = new ExportToCsv(options);
            csvExporter.generateCsv(current_ciclo);
        },
        downloadCiclos(){
            console.log('downloadCiclos');
            console.log(this.datos);
            let salida = []
            
            this.datos.sort((a, b) => new Date(a.fechahora_ensayo) - new Date(b.fechahora_ensayo));

            this.datos.forEach(element => {
                let prueba = new Date(element.fechahora_ensayo.replace(' ', 'T'));
                
                element['dia']=moment(prueba).format('YYYY-MM-DD')
                element['hora']=moment(prueba).format('HH:mm:ss')
                salida.push({
                    nombre: element.nombre,
                    dia: element.dia,
                    hora: element.hora,
                    trabajador: element.worker,
                    kg_entrada: element.kg_entrada,
                    kg_salida: element.kg_membrana_t2,
                    lote_mp: element.lote_mp,
                    lote_bolson: element.lote_bolson,
                    lote_mem_higenizada: element.lote_mem_higenizada,
                    tiempo_secado: this.calcularTiempoSecado(element.datos_de_ensayo.results)
                })
            });

            const options = { 
                fieldSeparator: ';',
                quoteStrings: '"',
                decimalSeparator: ',',
                showLabels: true, 
                showTitle: false, // Sin titulo
                title: "Prueba", // Si ponemos título especificamos aquí
                useTextFile: false,
                useBom: true,
                useKeysAsHeaders: true,
                filename: 'resumen-tromel-'+ this.fechaInicio
                // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
            };
            const csvExporter = new ExportToCsv(options);
            csvExporter.generateCsv(salida);
        },
        getCiclosRangoDia(fecha, hora){
            let total = []
            this.datosDesdeDíaAnterior.data.results.map(item => {
                let fecha_item = this.fecha_formateada(item.fechahora_ensayo).split(' ')[0]
                let hora_item = this.fecha_formateada(item.fechahora_ensayo).split(' ')[1].split(':')[0]
                if(fecha_item == fecha && hora_item > 6){
                    total.push(item)
                }
            })
            return total.length + 1
        },
        async getDatosEnsayosConFecha(f_inicio, f_fin){

            const payload = {
                path: 'ciclos/get-historico-ensayos',
                params: {
                    firstDay: f_inicio,
                    lastDay: f_fin}
            }
            this.datosDesdeDíaAnterior  = await this.getData(payload)


            // this.datosDesdeDíaAnterior = await this.axios.get('/get-historico-ensayos',
            // {
            //     params: {
            //         firstDay: f_inicio,
            //         lastDay: f_fin,
            //         // lote_mp: this.lote_mp,
            //         // worker: this.trabajador
            //     },
            //     headers: { "token": localStorage.getItem('token') }
            // });
        },
        diaAnterior2(ano, mes, dia){
            let mes_menos_uno = parseInt(mes) - 1 //Internamente empieza desde 0
            const yesterday = new Date(ano, mes_menos_uno.toString(), dia)
            //console.log(yesterday)
            yesterday.setDate(yesterday.getDate() - 1)
            return this.formatDate(yesterday)
        },
        diaASiguiente(ano, mes, dia){
            let mes_mas_uno = parseInt(mes) - 1 //Internamente empieza desde 0
            const manana = new Date(ano, mes_mas_uno.toString(), dia)
            manana.setDate(manana.getDate() + 1)
            return this.formatDate(manana)
        },
        padTo2Digits(num) {
            return num.toString().padStart(2, '0');
        },
        formatDate(date) { // yyyy-mm-dd
            return [
            date.getFullYear(),
            this.padTo2Digits(date.getMonth() + 1),
            this.padTo2Digits(date.getDate()),
            ].join('-');
        },
        async actualizarCiclosDesdeDíaAnterior(){
            let ayer = this.diaAnterior2(this.fechaInicio.split('-')[0],this.fechaInicio.split('-')[1],this.fechaInicio.split('-')[2])
            this.ciclosDesdeDiaAnterior = await this.getDatosEnsayosConFecha(ayer,this.fechaFin)
        },
        text_resultado(item){
            return (item.ok)?'Correcto':'Incorrecto'
        },
        color_conseguido(item){
            return (item.ok)?'success':'danger'
        },
        editItem(item){
            this.editedItem.id_ensayo = item.id_ensayo

            this.lote_mp = item.lote_mp
            this.lote_bolson = item.lote_bolson
            this.lote_membrana = item.lote_mem_higenizada
            this.editedItem.cuerpos_extr = item.cuerpos_extr == 'false' ? false : true,
            this.kg_membrana_t2 = item.kg_membrana_t2
            this.trabajador = item.worker

            //Guardamos estado anterior del item
            this.item_ant.lote_mp = item.lote_mp
            this.item_ant.lote_bolson = item.lote_bolson
            this.item_ant.lote_mem_higenizada = item.lote_mem_higenizada
            this.item_ant.kg_membrana_t2 = item.kg_membrana_t2

            this.editDialog = true
        },
        closeEdit(){
            this.editDialog = false
            this.editedItem.id_ensayo = -1
            this.editedItem.cuerpos_extr = false
        },
        async saveEdit() {
            const safeTrim = (val) => (val || "").toString().trim();

            try {
                // 1. Construir el objeto (validando que item_ant existe para que no explote)
                const ant = this.item_ant || {}; // Por seguridad, si item_ant es null, usamos objeto vacío

                let itemEditado = {
                    id_ensayo: this.editedItem.id_ensayo,
                    lote_mp: safeTrim(this.lote_mp),
                    lote_bolson: safeTrim(this.lote_bolson),
                    lote_mem_higenizada: safeTrim(this.lote_membrana),
                    kg_membrana_t2: safeTrim(this.kg_membrana_t2),

                    lote_mp_ant: safeTrim(ant.lote_mp),
                    lote_bolson_ant: safeTrim(ant.lote_bolson),
                    lote_mem_higenizada_ant: safeTrim(ant.lote_mem_higenizada),
                    kg_membrana_t2_ant: safeTrim(ant.kg_membrana_t2),

                    worker: safeTrim(this.trabajador),
                    id_usuario: localStorage.getItem('id_usuario'),
                };

                const payloadPut = {
                    path: 'ciclos/ensayo',
                    params: this.editedItem.id_ensayo,
                    body: itemEditado
                };

                // 2. Enviar a la BBDD
                console.log("Enviando datos...", payloadPut);
                await this.putData(payloadPut); 

                // 3. ACTUALIZACIÓN LOCAL (Sin recargar de la base de datos)
                // IMPORTANTE: Asegúrate de que 'this.ensayos' es el nombre de tu array de la tabla
                // Si tu array se llama 'items', cambia 'ensayos' por 'items' abajo.
                const lista = this.datos || this.items || []; 
                const index = lista.findIndex(i => i.id_ensayo === this.editedItem.id_ensayo);

                if (index !== -1) {
                    // Actualizamos solo los campos necesarios en el objeto local
                    const itemLocal = lista[index];
                    itemLocal.lote_mp = itemEditado.lote_mp;
                    itemLocal.lote_bolson = itemEditado.lote_bolson;
                    itemLocal.lote_mem_higenizada = itemEditado.lote_mem_higenizada;
                    itemLocal.kg_membrana_t2 = itemEditado.kg_membrana_t2;
                    itemLocal.worker = itemEditado.worker;

                    // En Vue 2 usamos $set para asegurar que la tabla se refresque visualmente
                    this.$set(lista, index, { ...itemLocal });
                }

                // 4. Éxito
                Swal.fire({
                    icon: 'success',
                    title: '¡Aceptada!',
                    text: 'Ensayo editado con éxito',
                    timer: 2000
                });

                // 5. Historial (en segundo plano, no bloqueamos el flujo con await si no es crítico)
                const payloadPost = {
                    path: `ciclos/ensayo-modificado/${this.editedItem.id_ensayo}`,
                    body: itemEditado
                };
                this.postData(payloadPost).catch(err => console.error("Error en log historial:", err));

                // 6. Limpiar y cerrar
                this.limpiarInterfaz();
                this.closeEdit();

            } catch (error) {
                // AQUÍ VERÁS EL ERROR REAL EN LA CONSOLA DEL NAVEGADOR (F12)
                console.error("Error completo:", error);
                
                let mensaje = "No se pudo guardar el cambio";
                if (error.response && error.response.data && error.response.data.message) {
                    mensaje = error.response.data.message;
                }

                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: mensaje
                });
            }
        },

        limpiarInterfaz() {
            this.lote_mp = '';
            this.lote_bolson = '';
            this.lote_membrana = '';
            this.kg_membrana_t2 = '';
            this.trabajador = '';
        },
        permisosUsuario(){
            if(localStorage.getItem('id_rol') != 2){ // Todos menos rol básico 
                this.permiso_admin = true
            }else{
                this.permiso_admin = false
            }
        },
        calcularTiempoSecado(lista) {
            let result = []
            lista.map(item => {
                if(item.phase == '2'){
                    result.push(item)
                }
            })

            return this.segundosAminutos(result.length)
        },
        segundosAminutos(duration){   
            // Hours, minutes and seconds
            var hrs = ~~(duration / 3600);
            var mins = ~~((duration % 3600) / 60);
            var secs = ~~duration % 60;

            // Output like "1:01" or "4:03:59" or "123:03:59"
            var ret = "";

            if (hrs > 0) {
                ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
            } else {
                ret += "00:"
            }

            ret += "" + mins + ":" + (secs < 10 ? "0" : "");
            ret += "" + secs;
            return ret;
        },
    }, //FIN methods
    
    created() {
        const fecha_split = this.fechaFin.split('-')
        this.fechaFin = this.diaASiguiente(fecha_split[0],fecha_split[1],fecha_split[2]);
        this.permisosUsuario()
        this.getDatosEnsayos()
    },
    components: {
        GraficoYTabla,
    },
}
</script>
<style>
    .pointer{
        cursor: pointer;
    }
    /* table.dataTable.dataTable_width_auto {
       width: auto;
    } */
</style>